export default __webpack_public_path__ + "images/470d4637be057dee555575d756daf893-houston_desktop.webp";